export default {
  Title: 'Caregiver Application',
  Subtitle: 'Join our community of professional caregivers',
  Save: 'Save',
  Saved: 'Saved',
  Back: 'Back',
  Next: 'Next',
};
